<!-- =========================================================================================
  File Name: FormSidebar
  Description: For adding or edditing user information
  ----------------------------------------------------------------------------------------
  Item Name: JogjaBagus Backoffice
  Author: Hifi Saputra
  Author Email: hifisaputra1@gmail.com
  Author URL: https://github.com/fei77
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ formTitle }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pb-6"
      :settings="settings"
    >
      <div
        class="p-6 vs-con-loading__container"
        id="form-sidebar"
      >

        <h6 class="fs-1 mb-2">Title</h6>
        <vs-input
          class="w-full"
          label="Title ID"
          v-model="formData.titleId"
        />
        <vs-input
          class="w-full mt-3"
          label="Title EN"
          v-model="formData.titleEn"
        />

        <h6 class="fs-1 mb-2 mt-5">Short Description</h6>
        <vs-textarea label="Short Description ID" v-model="formData.descriptionId"/>
        <vs-textarea label="Short Description EN" v-model="formData.descriptionEn"/>

        <upload-image
          :src="formData.icon"
          @upload-success="formData.icon = $event"
          label="Icon"
        />


      </div>
    </VuePerfectScrollbar>

    <div
      class="flex flex-wrap items-center justify-center p-6"
      slot="footer"
    >
      <vs-button
        class="mr-6"
        @click="submit"
      >Save</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
      >Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  props: {
    itemId: {
      type: String,
      default: null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    formTitle: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      loading: false,
      data: {}
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive;
      },
      set (val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    validate () {
      return (this.formData.titleId.length > 0)
    }
  },
  methods: {
    submit () {
      if (!this.validate) return false
      if (this.itemId) {
        this.updateItem();
      } else {
        this.createItem();
      }
    },
    updateItem () {
      this.$vs.loading();

      this.$store.dispatch('businessFeature/patch', this.formData)
        .then(() => {
          this.notifySuccess('Data updated')
          this.closeSidebar()
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    },
    createItem () {
      this.$vs.loading();

      this.$store.dispatch('businessFeature/insert', this.formData)
        .then(() => {
          this.notifySuccess('Data created')
          this.closeSidebar()
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    },
    closeSidebar () {
      this.$emit("closeSidebar")
    }
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
